// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"21":"change-password","563":"content","571":"settings","858":"custom-urls","929":"distributions"}[chunkId] + "." + {"21":"788f23de","563":"10ebce28","571":"ffb44f2c","858":"dd8dd27d","929":"ffb44f2c"}[chunkId] + ".css";
};